const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./views/${handle}`
    ).then((module) => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on('unmount', () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

export const AppViews = {
  addresses: asyncComponentFactory('customers/Addresses'),
  login: asyncComponentFactory('customers/Login'),
  collection: asyncComponentFactory('Collection'),
  search: asyncComponentFactory('Collection'),
};
